// extracted by mini-css-extract-plugin
module.exports = {"debug":"Tab_debug__12NH1","button":"Tab_button__3_Qyz","selected":"Tab_selected__1rIct"};